module.exports = __webpack_public_path__ + "img/vrart_profile.4614e095.jpg";